import React, {useState} from 'react';
import {graphql, Link, useStaticQuery} from 'gatsby';

export default function MainMenu(args): React.JSX.Element {
  const {allMenuItems, configPagesPageSettings} = useStaticQuery(graphql`
    query mainMenuData {
      allMenuItems(
        sort: { weight: ASC }
        filter: {
          menu_name: { eq: "main" }
          id: { glob: "menu-items-menu_link_content:*" }
        }
      ) {
        nodes {
          title
          url
        }
      }
      configPagesPageSettings {
        relationships {
          field_dashboard {
            path {
              alias
            }
          }
        }
      }
    }
  `);

  const [show, setShow] = useState(false);
  const toggle = () => {
    setShow(!show);
  };

  const currentUrl = typeof window !== 'undefined' ? location.pathname : '';
  const pageIsInActiveTrail = (linkUrl: string): boolean => {
    if (currentUrl.includes(`${linkUrl}/`))
      return true;
    if (currentUrl.includes(`/domein/`) || currentUrl == '/')
      return configPagesPageSettings.relationships.field_dashboard.path.alias === linkUrl || '/' === linkUrl;
    return false;
  };

  return (
    <div data-vl-tabs data-vl-tabs-responsive-label="Navigatie">
      <div className="vl-tabs__wrapper vl-u-spacer-top--small">
        <div className={show ? 'vl-tabs open' : 'vl-tabs'} data-vl-tabs-list="" role="tablist">
          {allMenuItems.nodes.map((link, idx) => {
            const additionalAttributes = pageIsInActiveTrail(link.url)
              ? {'aria-current': 'page'}
              : {};

            return (
              <Link
                {...additionalAttributes}
                key={idx}
                className="vl-tab"
                id={`vl-tab-nummer-${idx}`}
                role="tab"
                data-vl-tab=""
                aria-controls={`vl-tab-nummer-${idx}-pane`}
                to={link.url}
              >
                {link.title}
              </Link>
            );
          })}
        </div>
        <button
          type="button"
          data-vl-tabs-toggle=""
          aria-expanded="false"
          className="vl-tabs__toggle"
          data-vl-close="false"
          onClick={toggle}
        >
          <span>{show ? 'Navigatie sluiten': 'Navigatie openen'}</span>
        </button>
      </div>
    </div>
  );
}
